import { registerView, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import NiaViewModel from "../../../viewModels/notice/components/niaViewModel";

const NiaView: ViewComponent<NiaViewModel> = observer(({ vm }) => {
  return <></>;
});

registerView(NiaView, NiaViewModel);
